import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import { profileSettingsSetIsLoadingReducerType } from './ProfileSettingsConstants';

export const initialState = Map({
  isLoading: true,
});

const spec = {
  [profileSettingsSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
};

export default createReducerBySpec(spec, initialState);
